/**
 * Messages ids
 */
export const PLEASE_WAIT = 'pleaseWait';
